// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4db07e76","453":"86fd63e1","455":"e20728db"}[chunkId] + ".chunk.js";
};